import React, { type PropsWithChildren } from 'react';

import { Modal } from './Modal';
import { ConfirmModalFooter } from './ConfirmModalFooter';

import styles from './ConfirmModal.module.css';

interface ConfirmModalProps extends PropsWithChildren {
  readonly title?: string;
  readonly confirmLabel?: string;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
}

export const ConfirmModal = ({ title, confirmLabel, onConfirm, onCancel, children }: ConfirmModalProps) => {
  return (
    <Modal title={title} closeModal={onCancel}>
      <div className={styles.container}>
        {children}
        <ConfirmModalFooter onCancel={onCancel} onConfirm={onConfirm} confirmLabel={confirmLabel} />
      </div>
    </Modal>
  );
};
